var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        staticClass: "mt-4 mt-md-0 mt-sm-4",
        attrs: { page: _vm.headerConfig }
      }),
      _c("filter-manager", {
        attrs: { "display-advanced": false, filters: _vm.filterConfig },
        on: {
          academicYear: _vm.onAcademicYearChange,
          search: _vm.fetchAnnouncements
        },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultados" }
      }),
      _vm._l(_vm.pagination.data, function(row) {
        return _c("announcement-row", {
          key: row.id,
          attrs: {
            id: row.id,
            "area-id": row.areaId,
            code: row.code,
            description: row.description,
            "finish-date": row.finishDate,
            "has-submitted-proposals": row.hasSubmittedProposals,
            "is-proposal-determined": row.isProposalDetermined,
            name: row.name,
            "publish-date": row.publishDate,
            "status-id": row.status.id
          },
          on: { refresh: _vm.fetchAnnouncements, view: _vm.proposalRedirect }
        })
      }),
      !_vm.pagination.data
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": true },
            on: { "pagination-go-page": _vm.goToPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }